<!--
作者：Loong
时间：2020/04/10
-->
<!-- invoiceSwitch [ 发票开关 ] -->
<template>

    <div id='invoiceSwitch'>
        <el-table :data="listend" border style="width:1652px;text-align:center;margin-bottom: 10px;font-size:12px;">
			<el-table-column prop="name" label="小区名称" align="center" />
			<el-table-column label="小区开票状态" align="center">
                <template scope="scope">		
                    <div>
                        <el-switch v-model="scope.row.state" @change="onChangeState($event, scope.row.id)" active-color="#13ce66" inactive-color="#ff4949" active-text="开" inactive-text="关"></el-switch>
                    </div>
				</template>
            </el-table-column>
		</el-table>
		 <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            layout="total,prev, pager, next"
            :total="total"
            >
        </el-pagination>
    </div>

</template>

<script>
export default {
    components: { },

    props: [],

    data() {
        return{
            listend:[],
            numofid:0,
            adminId:'',
            total:0,
            pageSize:15,
        }
    },

    computed: { 

    },

    watch: {
        route: {
            handler: function(val, old){

            },
            deep: true
        }
    },

    created(){

    },

    mounted(){
        this.loadMain();

        this.getData();
    },

    methods:{
        loadMain(){

        },

        getData(){
            this.$jssdk.invoice.list({}, r => {
                this.listend = [];
                for(let i = 0; i < r.list.length; i ++){
                    this.listend.push({
                        id: r.list[i].id,
                        state: Number(r.list[i].life_switch) == 1 ? true : false,
                        name: r.list[i].name
                    })
                }
                // this.total = r.list.total
            })
        },

        //分页
        handleSizeChange(val) {

        },

        handleCurrentChange(val) {
            
        },

        // 切换状态
        onChangeState(val, id){
            this.$jssdk.invoice.edit({community_id: id, life_switch: val ? 1 : 0}, r => {
                console.log(r)
            })
            console.log(val)
        },
    },
}
</script>

<style lang='less'>

</style>

<style lang='less' scoped>

</style>


// WEBPACK FOOTER //
// InvoiceSwitch.vue?7211fc00